<template>
  <s-sub-header :pageName="pageName" :backButton="backButtonCategories">
    <template #categories>
      <ul>
        <li v-for="category in categories" :key="category.name">
          <div></div> <!-- this div align when inline-block -->
          <md-button
            v-if="category.name == 'Free' "
            @click="search(category, searchType)"
            class="md-sm small-screen-size"
            :class="[{ 'highlight-button': isSelected(category.name) }]"
          >
            <div class="categories-content">
              <img v-if="isCategorySelected(category.name)" src="/img/free-tag-label-blue.png" alt="" class="free-tag-size"/>
              <img v-else src="/img/free-tag-label.png" alt="" class="free-tag-size"/>
            </div>
          </md-button>
          <md-button
            v-else
            @click="search(category, searchType)"
            class="md-sm small-screen-size"
            :class="[{ 'highlight-button': isSelected(category.name) }]"
          >
            <div class="categories-content">
              <em :class="[category.iconClass]" class="fitting-adjustments">{{ category.icon }}</em>
              <span>{{ category.name }}</span>
            </div>
          </md-button>
        </li>
      </ul>
    </template>
  </s-sub-header>
</template>

<script>
import SSubHeader from "@/material-components/organisms/SSubHeader.vue";
import { mapGetters } from "vuex";
export default {
  name: "SubHeaderCategories",
  props: ["categories", "searchType", "pageName", "backButtonCategories"],
  components: {
    SSubHeader,
  },
  data() {
    return {
      selectedCategory: null,
    };
  },
  computed: {
    ...mapGetters({
      isUserAuthenticated: "isUserAuthenticated",
    }),

  },
  methods: {
    isSelected(categoryName){
      const categoryFromUrl = this.$route.params.query

      if(this.$route.fullPath.includes("?")){
        if (categoryFromUrl === categoryName){
          return true;
        } else {
          return false;
        }
      }
    },
    search(category){
      const USER_AUTHENTICATED = this.isUserAuthenticated
      const CATEGORY_SELECTED = this.isSelected(category.name)

      this.$emit("clearFilter")

      if(USER_AUTHENTICATED) {
        if (CATEGORY_SELECTED) {
          this.$router.push('/s-app/feed');
        } else {
          this.$router.push(`${category.searchQuery}`)
        }
      }

      if (!USER_AUTHENTICATED) {
        let filter = category.searchQuery.slice(21)

        if(CATEGORY_SELECTED) {
          this.$router.push('/')
        } else {
          this.$router.push(`/search-result-landing/${filter}`)
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.list-category ul {
  list-style: none !important;
  list-style-type: none;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.list-category ul li {
  display: inline-flex;
  max-width: 95px;
}
.categories-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.highlight-button {
  border: solid;
  border-color: $primary;
  background-color: white !important;
  color: $primary !important;
}
.small-screen-size {
  max-width: 70px;
  min-width: 70px;
  max-height: 50px;
  min-height: 50px;
}
.fitting-adjustments {
  margin-bottom: 5px;
}
@media screen and (max-width: 1192px) {
  .small-screen-size {
    max-width: 58px;
    min-width: 58px;
  }
}
.md-sm {
  font-family: inherit;
  background-color: #05919B;
  align-items: center;
  cursor: pointer;
  border-radius: 5px;
  display: flex;
  flex-basis: 70%;
  flex-shrink: 1;
  color: #fff;
}

.md-sm span {
  font-size: xx-small;
}

.icon {
  display: flex-start;
  font-size: larger;
}

.container {
  margin-top: 150px;
}

.electronic-class {
  margin-right: -1px !important;
}

.clothing-class {
  margin-right: 2px !important;
}

.household-class {
  margin-right: 3px !important;
}
.free-tag-size {
  width: 75%;
}

@media screen and (min-width: 1024px) and (max-width: 1300px) {
  .list-category ul {
    justify-content: center;
  }
}
@media screen and (max-width: 1024px) {
  .list-category ul {
    display: inline-block !important;
  }
}
</style>
